export default "__VITE_ASSET__CeI8uLfY__"